export const handleMensurationOthers = (prev, values, currentStep, callback) => {
	switch(currentStep){
		case "1"		: return validateStep1(prev, values, callback);
		case "2"		: return validateStep2(prev, values, callback);
		case "2-1"	: return validateStep21(prev, values, callback);
		case "3"		: return validateStep3(prev, values, callback);
		case "4"		: return validateStep4(prev, values, callback);
		default 		: return "1" ;
	}
};

function validateStep1(prev, values, callback) {
	if(prev) return "return";
	callback(mapToApi(values), "mensuration");
	return "2";
}

function validateStep2(prev, values, callback) {
	if(prev) return "1";
	callback(mapToApi(values), "mensuration");
	return values["2"] == "yes" ? "2-1" : "3";
}

function validateStep21(prev, values, callback) {
	if(prev) return "2";
	callback(mapToApi(values), "mensuration");
	return "3";
}

function validateStep3(prev, values, callback) {
	if(prev) return values["2"] == "yes" ? "2-1" : "2";
	callback(mapToApi(values), "mensuration");
	return "4";
}

function validateStep4(prev, values, callback) {
	if(prev) return "3";
	callback(mapToApi(values), "mensuration");
	return "end";
}

function mapToApi(values) {
	return {
		others: {
			"1" 	: values["1"] 	== "yes" ? true : false,
			"2" 	: values["2"] 	== "yes" ? true : false,
			"2-1" : values["2-1"] == "yes" ? true : false,
			"3" 	: values["3"] 	== "yes" ? true : false,
			"4" 	: values["4"] 	== "yes" ? true : false,

		}
	};
}


// WEBPACK FOOTER //
// src/helpers/subcategoriesFunctions/handleMensurationOthers.js